import React from 'react'
import styled from 'styled-components'
import VenueProfile from './venue-profile'
import Container from '../system/container/container'
import VenueInfo from '../../models/venue-info'
import { TopSection } from '../page-layouts/two-section-page'

const PACProfileContainer = styled(Container)`
  padding-top: ${props => props.theme.spacing.base300};

  p {
    color: ${props => props.theme.colors.typography.dark.text};
  }
`

const PACProfile = ({ profile }: { profile: VenueInfo }) => (
  <TopSection id="pac">
    <PACProfileContainer>
      <VenueProfile profile={profile} />
    </PACProfileContainer>
  </TopSection>
)

export default PACProfile
